var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerSupport = function SvgCustomerSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.572 10.286h1.714a.857.857 0 0 1 .857.857v4.286a.857.857 0 0 1-.857.857H2.572A1.714 1.714 0 0 1 .857 14.57V12a1.714 1.714 0 0 1 1.715-1.715Zm18.858 6h-1.715a.857.857 0 0 1-.857-.857v-4.286a.857.857 0 0 1 .857-.857h1.714A1.714 1.714 0 0 1 23.144 12v2.572a1.715 1.715 0 0 1-1.715 1.714Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.286 21a3.43 3.43 0 0 0 3.429-3.428v-1.286"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.143 18.857a2.143 2.143 0 1 1 0 4.286h-2.571a2.143 2.143 0 0 1 0-4.286zm-9.857-8.571V8.57a7.714 7.714 0 0 1 15.429 0v1.715M9.429 6.857V9.43m5.142-2.573V9.43m-5.142 3.427c0 2.28 5.143 2.28 5.143 0"
  })));
};
export default SvgCustomerSupport;